import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { publicKey } from 'config';

import AddAudio from '../AddAudio/AddAudio';

const ActivityAddAudio = ({ path, contentFolder, versionType, helpTab = false, preserveFiles = false, ...otherProps }) => {
  const filesPath = path || ((!helpTab && versionType?.indexOf('immersion') !== -1) 
  ? `${publicKey}/${contentFolder}/languageVersionData/${versionType}`
  : `${publicKey}/${contentFolder}/gamedata`);
  return (
    <AddAudio
      saveAfterChange
      withOverlay
      path={filesPath}
      withId={!otherProps.filename}
      versionType={versionType}
      {...otherProps}
      preserveFiles={preserveFiles}
      removeOldOnChange={preserveFiles ? false : (otherProps.removeOldOnChange !== undefined ? otherProps.removeOldOnChange : !otherProps.filename)}
    />
  );
};

ActivityAddAudio.propTypes = {
  path: PropTypes.string,
  contentFolder: PropTypes.string.isRequired
};

const mapStateToProps = ({ flinkMake: { activity } }) => ({
  preserveFiles: activity.editingActivity.template?.alias === 'MATH_RODS',
  contentFolder: activity.editingActivity.activity.contentFolder
});

export default connect(mapStateToProps)(ActivityAddAudio);
